import { Component, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirNavArrowDown } from '@ng-icons/iconoir';
import { AccordionContent } from '../../interfaces/apis/visits-statistics-dashboard';
import { ErrorStateComponent } from '../error-state/error-state.component';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  imports: [NgIcon, NgClass, ErrorStateComponent],
  styleUrls: ['./card.component.scss'],
  providers: [
    provideIcons({
      iconoirNavArrowDown,
    }),
  ],
})
export class StatisticalCardComponent {
  public accordionContent = input<AccordionContent | undefined>(undefined);
  public icon = input<string | undefined>('question-mark');
  public title = input<string | undefined>('Unknown');
  public info = input<string | undefined>('');
  public loading = input<boolean>(false);
  public hasError = input<boolean>(false);
  public errorMessage = input<string>('Failed to load data');
  public retryButtonText = input<string>('Retry');
  
  public onRetry = output<void>();

  isOpened = false;

  /**
   * @description Toggles card isOpened state
   */
  toggle = (): void => {
    this.isOpened = !this.isOpened;
  };

}
